import WordContext from "./WordContext";
import useWordList from './useWordList';

export default function WordProvider({ children }) {
  const [verbs, addVerb, removeVerb] = useWordList("verbs");
  const [nouns, addNoun, removeNoun] = useWordList("nouns");
  const [adjectives, addAdjective, removeAdjective] = useWordList("adjectives");
  const [reasons, addReason, removeReason] = useWordList("reasons");

  return (
    <WordContext.Provider
      value={{
        verbs, addVerb, removeVerb,
        nouns, addNoun, removeNoun,
        adjectives, addAdjective, removeAdjective,
        reasons, addReason, removeReason,
      }}
    >
      {children}
    </WordContext.Provider>
  );
};
